import { customAutoCompleteFilter } from "../../../../Shared/GlobalVariables/filterVariables";

/**
 * AX7UserLicenseController
 * Controller for the Dynamics 365 FSC User License wizard step
 * Handles license impact analysis display and linked request toggle
 */
export default /*@ngInject*/ function ($scope, RequestManagementAXLoadDataService) {
    // Initialize controller
    activate();

    function activate() {
        // Set up scope references
        $scope.vm = $scope.$parent.vm;
        // Initialize role details grid
        initializeRoleDetailsGrid();

        // Listen for wizard step changes - load analysis when navigating to this step
        $scope.$on('broadcast-im-wizardstepchange', async function (event, args) {
            if (args != null && args.toStep === 'Dynamics 365 for Finance and Supply Chain User License') {
                try {
                    await RequestManagementAXLoadDataService.loadAX7LicenseAnalysis($scope);
                    if ($scope.vm.showRoleDetails && $scope.vm.licenseAnalysisResult?.AllDrivingRoles?.length > 0) {
                        $scope.roleDetailsDataSource.data($scope.vm.licenseAnalysisResult.AllDrivingRoles);
                    }
                } catch (error) {
                    console.error('Failed to load license analysis:', error);
                }
            }
        });
    }

    /**
     * Initialize the Kendo Grid for Role Details
     */
    function initializeRoleDetailsGrid() {
        // Create data source
        $scope.roleDetailsDataSource = new kendo.data.DataSource({
            data: [],
            pageSize: 10,
            schema: {
                model: {
                    fields: {
                        RoleSystemName: { type: 'string' },
                        RoleName: { type: 'string' },
                        LicenseSku: { type: 'string' },
                        LicenseGroupName: { type: 'string' },
                        LicensePriority: { type: 'number' },
                        AadSkuId: { type: 'string' },
                        Action: { type: 'string' }
                    }
                }
            }
        });

        // Configure grid options
        $scope.roleDetailsGridOptions = {
            dataSource: $scope.roleDetailsDataSource,
            sortable: true,
            filterable: {
                mode: 'row'
            },
            pageable: {
                pageSize: 10,
                pageSizes: [10, 25, 50, 100]
            },
            columns: [
                {
                    field: 'Action',
                    title: 'Action',
                    width: 120,
                    filterable: customAutoCompleteFilter,
                    template: function(dataItem) {
                        if (dataItem.Action === 'Grant') {
                            return '<span class="label label-success"><i class="fa fa-plus"></i> Grant</span>';
                        } else if (dataItem.Action === 'Revoke') {
                            return '<span class="label label-danger"><i class="fa fa-minus"></i> Revoke</span>';
                        } else {
                            return '<span class="label label-default">' + dataItem.Action + '</span>';
                        }
                    }
                },
                {
                    field: 'RoleName',
                    title: 'Role Name',
                    width: 150,
                    filterable: customAutoCompleteFilter
                },
                {
                    field: 'RoleSystemName',
                    title: 'Role System Name',
                    width: 150,
                    filterable: customAutoCompleteFilter
                },
                {
                    field: 'LicenseSku',
                    title: 'License SKU',
                    width: 150,
                    filterable: customAutoCompleteFilter
                },
                {
                    field: 'LicenseGroupName',
                    title: 'License Group',
                    width: 150,
                    filterable: customAutoCompleteFilter
                },
                {
                    field: 'AadSkuId',
                    title: 'AAD SKU ID',
                    width: 200,
                    filterable: customAutoCompleteFilter,
                    template: function(dataItem) {
                        if (dataItem.AadSkuId) {
                            return '<span class="label label-default"><i class="fa fa-key"></i> ' + dataItem.AadSkuId + '</span>';
                        }
                        return '';
                    }
                }
            ],
            resizable: true,
            reorderable: true
        };
    }

}
